import { OwnerContractDetailOverview } from "../organism"

type OwnerContractDetailTemplateProps = {
  selectedSection: string
}

export const OwnerContractDetailTemplate = ({ selectedSection }: OwnerContractDetailTemplateProps) => {
  return (
    <>
      {
        (
          () => {
            switch(selectedSection) {
              case '1':
                return (
                  <OwnerContractDetailOverview />
                )
              
              case '2':
                return <p>Soy seccion 2</p>

              case '3':
                return <p>Soy seccion 3</p>


              default:
                console.warn('invalid option Contract tab option')
            }
          }
        )()
      }
    </>
  )
}
